import { useTenantContext } from '../tenant-context/index.tsx';

type CloudName = string;

export const useCloudName = (): CloudName => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.cloudName;
};
